import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Carrier } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { carrierKeys, createCarrierApi } from '../api';
import type { UpdateSiteEnablementRequest } from '../api/carrier.api';

export function useUpdateSiteEnablement(): UseMutationResult<Carrier, Error, UpdateSiteEnablementRequest> {
  const client = useApiClient('admin-auth');
  const api = createCarrierApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<Carrier, Error, UpdateSiteEnablementRequest>({
    mutationFn: (request: UpdateSiteEnablementRequest) => api.updateSiteEnablement(request),
    onError: () => {
      toast.error(t('sites.settings.carriers.edit.error'));
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: carrierKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: carrierKeys.detail(variables.carrierId) });
      toast.success(t('sites.settings.carriers.edit.success'));
    },
  });
}
